export * from './bericht-entfernt.interface';
